import { useState } from "react";
import LogOutOnly from "../../../components/Auth/LogOutOnly";
import { ISignUpCertificate, ISignUpLicense, ISignUpPharmacy, ISignUpUser } from "../../../types";
import CertificateInfo from "./CertificateInfo";
import Done from "./Done";
import Intro from "./Intro";
import Path from "./Path";
import PharmacyInfo from "./PharmacyInfo";
import PhoneAuth from "./PhoneAuth";
import PhoneInfo from "./PhoneInfo";
import UserInfo from "./UserInfo";
import { getNextStep, getStepProgress, SignUpStep, SignUpType } from "./types";
import LicenseInfo from "./LicenseInfo";

export default function SignUp() {

    /* step */

    const [step, setStep] = useState<SignUpStep>("type");

    /* 가입 객체는 단계마다 따로 모은 뒤, Path에서 한 번에 제출한다. */

    const [userData, setUserData] = useState<Partial<ISignUpUser>>({});
    const [licenseData, setLicenseData] = useState<Partial<ISignUpLicense>>({});
    const [certificateData, setCertificateData] = useState<Partial<ISignUpCertificate>>({});
    const [pharmacyData, setPharmacyData] = useState<Partial<ISignUpPharmacy>>({});

    /* userType */

    const userType = userData.type as SignUpType | undefined;

    /* progress */

    const progress = getStepProgress(step, userType);

    /* onNext */

    const onNext = () => {

        /* 다음 단계 계산: 선택된 userType에 따라 다음 단계가 결정된다. */

        const nextStep = getNextStep(step, userType);

        /* 다음 단계 설정: type, agree, phone, phoneAuth, userInfo 까지는 공통 */

        if (nextStep) setStep(nextStep);
    };

    return (
        <LogOutOnly>

            {/* 1~2. 유형 선택, 약관 동의 */}

            {(step === "type" || step === "agree") && (
                <Intro
                    step={step}
                    userData={userData}
                    setUserData={setUserData}
                    onNext={onNext}
                />
            )}

            {/* 3. 휴대폰 번호 입력 + 인증번호 발송 */}

            {step === "phone" && (
                <PhoneInfo
                    progress={progress}
                    setUserData={setUserData}
                    onNext={onNext}
                />
            )}

            {/* 4. 인증번호 확인 */}

            {step === "phoneAuth" && (
                <PhoneAuth
                    progress={progress}
                    userData={userData}
                    onNext={onNext}
                />
            )}

            {/* 5. 공통 회원정보 (이름, 이메일, 비밀번호) */}

            {step === "userInfo" && (
                <UserInfo
                    progress={progress}
                    setUserData={setUserData}
                    onNext={onNext}
                />
            )}

            {/* 개국/일반 약사: 면허 객체 */}

            {step === "licenseInfo" && (
                <LicenseInfo
                    progress={progress}
                    setLicenseData={setLicenseData}
                    onNext={onNext}
                />
            )}

            {/* 약대생: 재학증명 객체 */}

            {step === "certificateInfo" && (
                <CertificateInfo
                    progress={progress}
                    setCertificateData={setCertificateData}
                    onNext={onNext}
                />
            )}

            {/* 개국 약사: 약국 객체 */}

            {step === "pharmacyInfo" && (
                <PharmacyInfo
                    progress={progress}
                    setPharmacyData={setPharmacyData}
                    onNext={onNext}
                />
            )}

            {/* 유입 경로 입력 후 signUp 제출 */}

            {step === "path" && (
                <Path
                    progress={progress}
                    userData={userData}
                    setUserData={setUserData}
                    licenseData={licenseData}
                    certificateData={certificateData}
                    pharmacyData={pharmacyData}
                    onNext={onNext}
                />
            )}

            {step === "done" && <Done />}
        </LogOutOnly>
    );
}
